import Showcase from '../lib/em/Showcase';

window.em = window.em || {};
window.em.showcase = new Showcase();